import { createSubApp as createSubAppBase } from '../../../../commons/portal-init/create-sub-app'
import { createAppI18n } from '../../../../shared/setup-i18n'

const i18n = createAppI18n('commonHeader')

export function createSubApp({ plugins = [], ...rest }) {
  return createSubAppBase({ ...rest, plugins: [i18n, ...plugins] })
}
